import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

export const CalendarDashboardLearnerApi = createApi({
  reducerPath: "calendarDashboardLearnerApi",
  baseQuery: customBaseQuery,
  tagTypes: ["events"],
  endpoints: (builder) => ({
    getAllEventsForLearner: builder.query({
      query: (pageSize: number) => {
        return {
          url: `/event?pageSize=${pageSize}`,
          method: "GET"
        };
      },
      providesTags: ["events"]
    }),
    getSearchEventsForLearner: builder.query({
      query: (body: any) => {
        return {
          url: `/search/calendar/myCalendar`,
          method: "POST",
          body: body
        };
      }
    })
  })
});

export const {
  useGetAllEventsForLearnerQuery,
  useGetSearchEventsForLearnerQuery
} = CalendarDashboardLearnerApi;
